import styled from 'styled-components';

export const TooltipContent = styled.div`
  max-width: 450px;
  text-align: left;
  padding: 4px;
  word-break: break-word;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 14px;
  line-height: 1.4;
`;

export const TooltipTitle = styled.strong`
  display: block;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.colors.textActive};
  font-weight: 600;
  font-size: 14px;
`;

export const TooltipDetail = styled.div`
  font-size: 13px;
  line-height: 1;
  margin-top: 2px;
  color: ${({ theme }) => theme.colors.textRegular};
`;

export const TooltipSmallLabel = styled.p`
  font-size: 12px;
  font-style: italic;

  line-height: 1;
  color: ${({ theme }) => theme.colors.textRegular};
`;

export const TooltipDetailHighlight = styled.span`
  font-style: italic;
  color: ${({ theme }) => theme.colors.textActive};
`;
